export default __webpack_public_path__ + "static/media/manage.982c4826.svg";